import Button from '@doordash/component-button'
import { Text, Colors, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../../actions'
import {
  DeliveryIssue,
  DeliveryIssueTypes,
  PolicyViolationPages,
} from '../../../../models/types'
import routes from '../../../../routes'
import { getCriticalDeliveryIssues } from '../../../../selectors/deliveryIssues'
import { UndecoratedLink } from '../components/styles'
import ExtremelyLateImage from '../images/extremely-late'
import t from './strings'
import { Container, ContentContainer, ImageContainer } from './styles'
import NavBar from '@doordash/component-navbar'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../constants'
import { goToDeepLink } from '../utilities'
import { PolicyViolation, EventActions } from '../../../../typeModules/events'
import * as events from '../../../../events'

type ExtremelyLateProps = {
  getDeliveryIssuesList: (dasherId: string) => void
  criticalDeliveryIssues: DeliveryIssue[]
  dasherId: string
  track: (data: PolicyViolation) => Promise<any>
}
/**
 * A clone of the original TakeOver screen for never delivered but
 * replaced with extreme lateness verbage and assets.
 * @param {ExtremelyLateProps} props
 */

const ExtremelyLate: React.FunctionComponent<ExtremelyLateProps> = props => {
  const {
    dasherId,
    getDeliveryIssuesList,
    criticalDeliveryIssues,
    track,
  } = props

  React.useEffect(() => {
    track({
      type: DeliveryIssueTypes.ExtremelyLate,
      page: PolicyViolationPages.Takeover,
      action: EventActions.Rendered,
    })
  }, [track])

  /**
   * fetch delivery issues list
   */
  React.useEffect(() => {
    getDeliveryIssuesList(dasherId)
  }, [dasherId, getDeliveryIssuesList])

  return (
    <Container>
      <NavBar
        isSeparatorVisible={false}
        navigationType={NavBar.NavigationTypes.Close}
        onNavigationClick={() => {
          track({
            type: DeliveryIssueTypes.ExtremelyLate,
            page: PolicyViolationPages.Takeover,
            action: EventActions.Clicked,
            data: {
              name: EventActions.Close,
            },
          })
          goToDeepLink({
            ios: IOS_CLOSE_DEEPLINK,
            android: ANDROID_CLOSE_DEEPLINK,
          })
        }}
      />
      <ImageContainer>
        <ExtremelyLateImage />
      </ImageContainer>
      <ContentContainer>
        <StackChildren>
          <Text
            styles={Text.Styles.Bold24}
            textAlign={Text.TextAlignments.Center}
          >
            {t.extremelyLateTitle()}
          </Text>
          <Text color={Colors.SystemGrey60}>
            {t.extremelyLateDescription1()}
          </Text>
          <Text color={Colors.SystemGrey60}>
            {t.extremelyLateDescription2()}
          </Text>
        </StackChildren>
        <UndecoratedLink
          to={
            criticalDeliveryIssues.length === 1
              ? routes.deliveryIssueDetail.buildPath({
                  id: criticalDeliveryIssues[0].id,
                })
              : routes.deliveryIssueList.path
          }
        >
          <Button
            type={Button.Types.PrimaryPill}
            onClick={() =>
              track({
                type: DeliveryIssueTypes.ExtremelyLate,
                page: PolicyViolationPages.Takeover,
                action: EventActions.Clicked,
                data: {
                  name: EventActions.Continue,
                },
              })
            }
          >
            {t.continue()}
          </Button>
        </UndecoratedLink>
      </ContentContainer>
    </Container>
  )
}

const mapStateToProps = state => ({
  criticalDeliveryIssues: getCriticalDeliveryIssues(state),
  dasherId: state.dasherId,
})
const mapDispatchToProps = {
  getDeliveryIssuesList: actions.getDeliveryIssuesList,
  track: events.trackPolicyViolations,
}
export const DisconnectedExtremelyLate = ExtremelyLate
export default connect(mapStateToProps, mapDispatchToProps)(ExtremelyLate)
